// extracted by mini-css-extract-plugin
module.exports = {"Card":"ProfileCard_Card__29qh2","Picture":"ProfileCard_Picture__1uftS","Name":"ProfileCard_Name__3Y4Au","Likes":"ProfileCard_Likes__2NMjr"};